import React, { useReducer, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import initialState from "./initialState";
import { STATE_CULTURE } from "../Actions/stateActions";
export const AppContext = React.createContext();

let source;
export const CLOSE_BOOKINGSMODAL = "close_bookingsmodal";
export const CLOSE_MENU = "close_menu";
export const CLOSE_TOAST = "close_toast";
export const OPEN_BOOKINGSMODAL = "open_bookingsmodal";
export const OPEN_TOAST = "open_toast";
export const SET_COURSEFILTER = "set_coursefilter";
export const SET_LANDINGTEXT = "set_landingtext";
export const SET_FOOTERTEXT = "set_footertext";
export const SET_HEADERTEXT = "set_headertext";
export const SET_OCCASIONFILTER = "set_occasionfilter";
export const SET_TERMSTEXT = "set_termstext";
export const TOGGLE_BOOKINGS = "toggle_bookings";
export const TOGGLE_MENU = "toggle_menu";
export const TOGGLE_SETTINGS = "toggle_settings";

const getState = (state) => ({
  activePerson: state.activePerson,
});

const reducer = (state, action) => {
  switch (action.type) {
    case CLOSE_BOOKINGSMODAL:
      return {
        ...state,
        bookingModal: { ...state.bookingModal, open: false, bookingData: {} },
      };
    case CLOSE_MENU:
      return { ...state, menuOpen: false };
    case CLOSE_TOAST:
      return { ...state, toastOpen: false, toastText: "", toastType: "" };
    case OPEN_BOOKINGSMODAL:
      return {
        ...state,
        bookingModal: {
          ...state.bookingModal,
          open: true,
          bookingData: action.payload,
        },
      };
    case OPEN_TOAST:
      return {
        ...state,
        toastOpen: true,
        toastText: action.toastText,
        toastType: action.toastType,
      };
    case SET_COURSEFILTER:
      const {
        type: courseType,
        value: courseValue,
        checked: courseChecked,
      } = action.payload;
      let newCourseFilter = {};
      if (courseType === "showOnlyBookable") {
        newCourseFilter = {
          ...state.courseFilter,
          showOnlyBookable: courseChecked,
        };
        return { ...state, courseFilter: newCourseFilter };
      }
      if (courseChecked) {
        newCourseFilter = {
          ...state.courseFilter,
          [courseType]: [...state.courseFilter[courseType], courseValue],
        };
        return { ...state, courseFilter: newCourseFilter };
      }
      const newCourseSubFilter = state.courseFilter[courseType].filter(
        (f) => f !== courseValue
      );
      newCourseFilter = {
        ...state.courseFilter,
        [courseType]: newCourseSubFilter,
      };
      return { ...state, courseFilter: newCourseFilter };
    case SET_LANDINGTEXT:
      return { ...state, landingText: action.payload };
    case SET_FOOTERTEXT:
      return { ...state, footerText: action.payload };
    case SET_HEADERTEXT:
      return { ...state, headerText: action.payload };
    case SET_TERMSTEXT:
      return { ...state, termsText: action.payload, fetchText: false };
    case SET_OCCASIONFILTER:
      const { type, value, checked } = action.payload;
      let newOccasionFilter = {};
      if (checked) {
        newOccasionFilter = {
          ...state.occasionFilter,
          [type]: [...state.occasionFilter[type], value],
        };
        HandleStoredFilters(newOccasionFilter, action.payload);
        return { ...state, occasionFilter: newOccasionFilter };
      }
      const newSubFilter = state.occasionFilter[type].filter(
        (f) => f !== value
      );
      newOccasionFilter = {
        ...state.occasionFilter,
        [type]: newSubFilter,
      };
      HandleStoredFilters(newOccasionFilter, action.payload);
      return { ...state, occasionFilter: newOccasionFilter };
    case TOGGLE_BOOKINGS:
      return { ...state, bookingsOpen: !state.bookingsOpen };
    case TOGGLE_MENU:
      return { ...state, menuOpen: !state.menuOpen };
    case TOGGLE_SETTINGS:
      return { ...state, settingsOpen: !state.settingsOpen };
    default:
      throw new Error(`Wrong action type: ${action.type}`);
  }
};

const HandleStoredFilters = (newOccasionFilter, actionPayload) => {
  const { type, value, checked } = actionPayload;
  const activeFilters = JSON.parse(localStorage.getItem("ActiveFilters"));
  if (checked === false) {
    localStorage.setItem("ActiveFilters", JSON.stringify(newOccasionFilter));
  } else if (checked === true) {
    if (activeFilters && activeFilters[type].includes(value)) {
      return;
    } else {
      localStorage.setItem("ActiveFilters", JSON.stringify(newOccasionFilter));
    }
  }
};

const AppContextProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const rdxState = useSelector((state) => getState(state));
  const rdxDispatch = useDispatch();
  const { landingText, headerText, footerText, fetchText } = state;
  const { culture } = useSelector((state) => ({
    culture: state.cookies[STATE_CULTURE],
  }));
  useEffect(() => {
    if (culture) {
      let CancelToken = axios.CancelToken;
      source = CancelToken.source();
      axios
        .all([
          axios.get(`/ee-static/booking/Texts/landing.${culture}.md`, {
            cancelToken: source.token,
          }),
          axios.get(`/ee-static/booking/Texts/header.${culture}.md`, {
            cancelToken: source.token,
          }),
          axios.get(`/ee-static/booking/Texts/footer.${culture}.md`, {
            cancelToken: source.token,
          }),
          axios.get("/ee-static/booking/Texts/terms.md", {
            cancelToken: source.token,
          }),
        ])
        .then(
          axios.spread((landingText, headerText, footerText, termsText) => {
            dispatch({ type: SET_LANDINGTEXT, payload: landingText.data });
            dispatch({ type: SET_FOOTERTEXT, payload: footerText.data });
            dispatch({ type: SET_HEADERTEXT, payload: headerText.data });
            dispatch({ type: SET_TERMSTEXT, payload: termsText.data });
          })
        )
        .catch((error) => {
          if (!axios.isCancel(error)) {
            console.log(error);
          }
        });
    }
    return () => source.cancel("Component Home Is Unmounting");
  }, [landingText, headerText, footerText, fetchText, culture]);

  return (
    <AppContext.Provider
      value={{
        state: {
          ...state,
          ...rdxState,
        },
        dispatch,
        rdxDispatch,
      }}
    >
      {props.children}
    </AppContext.Provider>
  );
};

export default AppContextProvider;
